/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const OemsListQueryParams = zod.object({
  "limit": zod.number().optional().describe('Number of results to return per page.'),
  "offset": zod.number().optional().describe('The initial index from which to return the results.')
})

export const OemsListResponse = zod.object({
  "count": zod.number(),
  "next": zod.string().url().nullish(),
  "previous": zod.string().url().nullish(),
  "results": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()




export const OemsCreateBody = zod.object({
  "name": zod.string().min(1)
})

export const OemsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict()

export const OemsRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this oem.')
})

export const OemsRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict()

export const OemsUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this oem.')
})




export const OemsUpdateBody = zod.object({
  "name": zod.string().min(1)
})

export const OemsUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict()

export const OemsPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this oem.')
})




export const OemsPartialUpdateBody = zod.object({
  "name": zod.string().min(1).optional()
})

export const OemsPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true})
}).strict()

export const OemsDestroyParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this oem.')
})

export const OemsDestroyResponse = zod.void()

